<template>
  <section class="content">
    <box >
      <div slot="body">
        <div class="row">
          <div class="col-md-12">
              <h4>Nome</h4>
              <input v-model="funcionarioLocal.nome" type="text" class="form-control">
              <label v-if="nome===''">*Campo Obrigatório</label>
          </div>
      </div>
      <div class="row">
          <div class="col-md-3">
              <h4>Horário Entrada</h4>
              <input v-model="funcionarioLocal.hr_entrada" type="time" class="form-control">
          </div>
          <div class="col-md-3">
              <h4>Horário Saída</h4>
              <input v-model="funcionarioLocal.hr_saida" type="time" class="form-control">
          </div>
          <div class="col-md-3">
              <h4>Inicio Intervalo</h4>
              <input v-model="funcionarioLocal.hr_inicio_intervalo" type="time" class="form-control">
          </div>
          <div class="col-md-3">
              <h4>Fim Intervalo</h4>
              <input v-model="funcionarioLocal.hr_fim_intervalo" type="time" class="form-control">
          </div>
      </div><br>
      <div class="row">
        <div class="col-md-12">         
          <multi-select :options="servicos"
                       :selected-options="funcionarioLocal.funcao"
                       placeholder="select item"
                       @select="onSelect">
        </multi-select>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <h4>Imagem </h4>
          <input type="file" id="file-input">
          <p id="status">Please select a file</p>
        </div>
      </div>
      <br>
      <div class="row">
        <div class="col-md-1">
          <h4>Ativo</h4>
            <toggle-button 
              v-model="funcionarioLocal.ativo"
              :color="color" 
              :sync="true" />
        </div>
      </div>
      <br><br>
      <router-link class="pageLink" to="/colaborador">
              <button class="btn btn-danger" >Cancelar</button>
      </router-link>
      <button class="btn btn-success" @click="gravar" v-show="habilitaGravar && !gravando" >
        <i class="fa fa-check">  Gravar</i>
      </button>
      <button v-show="gravando" class="btn btn-success"><i class="fa fa-spinner fa-spin"></i>  Gravando</button>
      </div>
    </box>
  </section>
</template>

<script>
import resource from './resource';
import resourceServicos from '../Servicos/resource'
import Box from '../Box'
import { MultiSelect } from 'vue-search-select'
import _ from 'lodash'
import s3 from '../../../services/s3'

export default {
  components: {
    'box': Box,
    MultiSelect
  },
  data: () => ({
    lastSelectItem: {},
    dialog: false,
    funcionario: {},
    loading: false,
    dialogErro: false,
    erro: '',
    servicos: [],
    alteracao: false,
    idEditar: 0,
    funcionarioLocal: {
      nome: '',
      hr_entrada: null,
      hr_saida: null,
      hr_inicio_intervalo: null,
      hr_fim_intervalo: null,
      imagem: '',
      funcao: [],
      ativo: false
    },
    ativo: false,
    gravando: false
  }),
  created() {
    this.getServicos()
    if(this.$route.params.id) {
      console.log('alterando');
      this.alteracao = true
      this.idEditar = this.$route.params.id
      this.getFuncionario(this.idEditar)
    }
  },
  computed: {
    nome: function () {
      if(this.alteracao) return 'alteracao Funcionário'
      else return 'Novo Funcionário'
    },
    habilitaGravar: function() {
      return this.funcionarioLocal.nome && this.funcionarioLocal.hr_entrada && this.funcionarioLocal.hr_saida && this.funcionarioLocal.hr_inicio_intervalo && this.funcionarioLocal.hr_fim_intervalo && this.funcionarioLocal.funcao   
    }
  },
  methods: {
    onSelect (items, lastSelectItem) {
      this.funcionarioLocal.funcao = items
      this.lastSelectItem = lastSelectItem
      setTimeout(function(){ 
          $('.delete').removeClass('detele').addClass('fa fa-trash');
      }, 100);
    },
    // deselect option
    reset () {
      this.items = [] // reset
    },
    // select option from parent component
    selectFromParentComponent () {
      this.items = _.unionWith(this.items, [this.options[0]], _.isEqual)
    },
    getServicos() {
      resourceServicos.getListaServicos().then((res) => {
        res.data.forEach((element, index) => {
          this.servicos.push({
            id: element.id,
            text: element.nome,
            value: index
          })
        });
        this.dialog = true
        console.log('servicos ==> ', this.servicos)
      })
    },
    gravar () {
      this.gravando = true
      const files = document.getElementById('file-input').files;
      const file = files[0];

      if(file != null) {
        s3.getSignedRequest(file).then(res => {
          this.funcionarioLocal.imagem = res.url
          this.submit();
        }).catch(err => {
          alert('Erro ao salvar imagem');
        })
      } else {
        if(this.alteracao) {
          this.submit();
        } else {
          alert('É necessário selecionar uma imagem.');
          this.gravando = false
        }
      }
          // this.imagem = 'https://s3-sa-east-1.amazonaws.com/baita-batata/baitabatata-logo.jpg'
          // this.gravarProduto()
    },
    async submit() {
      let funcionario = await _.pickBy(this.funcionarioLocal, function(a){ return a !== null });
      if(this.alteracao) {
        resource.atualizaFuncionario(funcionario, this.idEditar).then((res) => {
          this.dialog = false;
          this.idEditar = null;
          this.alteracao = false;
          this.$router.go(-1)
        }).catch(responseError => {
          this.dialogErro = true
          this.erro = responseError.response.data.message
          this.loading =false
        });
      } else {
        resource.gravaFuncionario(this.funcionarioLocal).then((res) => {
          this.dialog = false;
          this.idEditar = null;
          this.alteracao = false;
          this.$router.go(-1)
        }).catch(responseError => {
          this.dialogErro = true
          this.erro = responseError.response.data.message
          this.loading =false
        })
      }
    },
    getFuncionario() {
      resource.getFuncionario(this.idEditar).then((res) => {
        let data = res.data
        this.funcionarioLocal = {
          id: data.id,
          nome: data.nome,
          hr_entrada: data.hr_entrada,
          hr_saida: data.hr_saida,
          hr_inicio_intervalo: data.hr_inicio_intervalo,
          hr_fim_intervalo: data.hr_fim_intervalo,
          imagem: data.imagem,
          ativo: data.ativo,
          funcao: data.funcoes.map((element, index) => ({ id: element.id, text: element.nome, value: index }))
        }
        console.log('funcionario => ', this.funcionarioLocal)
        setTimeout(function(){ 
            $('.delete').removeClass('detele').addClass('fa fa-trash');
        }, 100);
      });
    },
    close() {
      this.setFuncionarioNull()
      this.dialog = false; 
      this.$emit('close');
    },
    setFuncionarioNull() {
      this.debito = {
        qtde_parcelas: null,
        honorarios: null,
        url_documento: null,
        total_debito: null,
        parcelas: [{
          data_vencimento: null,
          valor: null,
          juros: null,
          correcao: null,
        }],
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// novoFuncionario.vue?5939cc63